import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

const Nuevanotificacion = () => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const handleClick = () => {
    navigate('/dashboard', { replace: true });
  };

  const manejadorLogin = async () => {
    navigate('/dashboard/notificacion', { replace: true });
  };

  return (
    <>
      <Stack spacing={3}>
        <Typography variant="h4" gutterBottom>
          Agregar Nueva Notificación
        </Typography>
        <TextField name="email" label="Titulo" />
        <TextField name="email" label="Mensaje" />
        <TextField name="email" label="Fecha Creación" />
      </Stack>
      <br />
      <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={manejadorLogin}>
        Agregar
      </LoadingButton>
    </>
  );
};

export default Nuevanotificacion;
